<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Shift Assign
            <v-icon right>add_circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-select
                :items="shiftInfoList"
                label="Shift Name"
                v-model="queryParams.shiftInfoId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
                <v-card>
                  <v-card-title class="blue darken-3">
                    <span class="headline white--text">Summary</span>
                  </v-card-title>
                  <v-card-text class="font-weight-bold">
                    <div>
                      <v-btn
                        color="primary"
                        :loading="buttonLoading"
                        @click="reprintReport('printReport')"
                      >PRINT ALL</v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="shiftAssignList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :pagination.sync="pagination"
            :must-sort="true"
            expand
          >
            <template slot="items" slot-scope="props">
              <tr @click="props.expanded = !props.expanded">
                <td>
                  <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </td>
                <td>{{ props.item.assignDate }}</td>
                <td>{{ props.item.shiftInfoName}}</td>
                <td>{{ props.item.shiftAssignNo}}</td>
                <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date }}</td>
                <td>{{ props.item.updatedBy }}</td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :headers="subHeaders"
                    :items="props.item.assignDetailList"
                    item-key="props.item.id"
                    hide-actions
                    class="elevation-10"
                    :must-sort="true"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td class="text-xs">{{ subprops.item.username }}</td>
                      <td class="text-xs">{{ subprops.item.counterName }}</td>
                      <td>
                        <v-icon v-if="subprops.item.status" medium color="green">check_circle</v-icon>
                        <v-icon v-else medium color="red">cancel</v-icon>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

     <!-- <summary report> -->
    <div id="printReport" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:15px;margin:1px">Shift Assign Report</p>
      </div>
      <div style="text-align:center">
        <p
          style="font-size:15px;margin:1px"
        >From: [{{queryParams.fromDate}}] To: [{{queryParams.toDate}}]</p>
      </div>
      <br />
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:12px;border-top:1px solid black"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="border:1px solid black;text-align:center">Assign Date</th>
              <th style="border:1px solid black;text-align:center">Shift Name</th>
              <th style="border:1px solid black;text-align:center">ShiftAssign No</th>
              <th style="border:1px solid black;text-align:center">User</th>
              <th style="border:1px solid black;text-align:center">Counter Name</th>
            </tr>
          </thead>
          <tbody v-for="(item, i) in allShiftAssignList" :key="i">
            <tr v-for="(detail, index) in item.assignDetailList" :key="index">
                <td style="border:1px solid black;text-align:left;vertical-align:top;" :rowspan="item.assignDetailList.length" v-if="index == 0">
                  {{ item.assignDate }}</td>
                <td style="border:1px solid black;text-align:left;vertical-align:top;" :rowspan="item.assignDetailList.length" v-if="index == 0">
                  {{ item.shiftInfoName}}</td>
                <td style="border:1px solid black;text-align:left;vertical-align:top;" :rowspan="item.assignDetailList.length" v-if="index == 0">
                  {{ item.shiftAssignNo}}</td>
                <td style="border:1px solid black;text-align:left">{{ detail.username }}</td>
                <td style="border:1px solid black;text-align:left">{{ detail.counterName }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { shiftAssignService } from "../../services/shift-assign-service";
import { commonService } from "../../services/common-service";
import { shiftInfoService } from "../../services/shift-info-service";
export default {
  name: "ShiftAssignList",

  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    buttonLoading: false,
    breadcrumbs: [
      {
        text: "User Management",
        disabled: true
      },
      {
        text: "Shift Assigns",
        disabled: true
      }
    ],
    headers: [
      { text: "Action", value: "name", sortable: false },
      { text: "Assign Date", value: "assignDate" },
      { text: "Shift Name", value: "shiftInfoName" },
      { text: "ShiftAssign No", value: "shiftAssignNo" },
      { text: "Updated  Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    subHeaders: [
      { text: "Username", value: "username" },
      { text: "Counter Name", value: "counterName" },
      { text: "Status", value: "status" }
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "assignDate",
      totalItems: 0
    },
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      shiftInfoId: "",
      shopId: "",
      updateUserId: ""
    },
    shiftAssignList: [],
    shiftInfoList: [],
    allShiftAssignList: [],
    totalRows: 0,
    clonequeryParams: new Object(),
    sortedBy: "assignDate,desc"
  }),
  watch: {
    pagination: {
      handler() {
        this.getShiftAssignList();
      },
      deep: true
    }
  },
  created() {
    if (this.user.role.roleName == "SALE_MANAGER") {
      this.queryParams.updateUserId = this.user.id;
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.shiftInfoId) {
      this.queryParams.shiftInfoId = this.$route.query.shiftInfoId;
    }
    if (this.$route.query.updateUserId) {
      this.queryParams.updateUserId = this.$route.query.updateUserId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    let user = JSON.parse(localStorage.getItem("user"));
    this.queryParams.shopId = user.shopId;
    this.getShiftInfosByShopId(this.queryParams.shopId);
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "shift-assigns", query: this.queryParams });
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
      this.getShiftAssignList();
    },
    getShiftInfosByShopId(shopId) {
      shiftInfoService
        .getShiftInfosByShopId(shopId)
        .then(res => {
          this.shiftInfoList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getShiftAssignList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      shiftAssignService
        .getShiftAssignList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          this.shiftAssignList = res.data.assignList;
          this.totalRows = res.data.totalElements;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
     reprintReport(divName) {
        this.buttonLoading = true;
        shiftAssignService
          .getAllShiftAssignList(this.clonequeryParams)
          .then(res => {
            this.allShiftAssignList = res.data.assignList;
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            var printContents = document.getElementById(divName).innerHTML;
            var reprintWindow = window.open(
              "",
              "MsgWindow",
              "width=500,height=500"
            );
            reprintWindow.document.write(printContents);
            setTimeout(() => {
              reprintWindow.print();
              reprintWindow.close();
            }, 600);
            this.buttonLoading = false;
          });
      },
    onRegister() {
      this.$router.push("/shift-assign/new");
    },
    onEdit(shiftAssign) {
      // go to details page
      this.$router.push("/shift-assign/" + shiftAssign.id);
    }
  }
};
</script>

<style scoped>
</style>